import { defineComponent as _defineComponent } from 'vue';
import AzIcon from '~/components/_next/atoms/AzIcon.vue';
export default /*#__PURE__*/_defineComponent({
  __name: 'InformationItem',
  props: {
    message: null,
    icon: null
  },
  setup: function setup(__props) {
    var props = __props;
    var hasMessage = computed(function () {
      return !!(props !== null && props !== void 0 && props.message);
    });
    return {
      __sfc: true,
      props: props,
      hasMessage: hasMessage,
      AzIcon: AzIcon
    };
  }
});